export default {
  methods: {
    removeUrlTrailingSlash(url) {
      if (!url) return;
      return url.trim().replace(/\/$/, '');
    },
    assignURLToCurrentTab(url) {
      window.location.assign(url);
    },
    openURLInNewTab(url) {
      window.open(url, '_blank');
    },
  },
};
